/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class FileUploadControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fileUploadControllerFileDataUpload
   */
  static readonly FileUploadControllerFileDataUploadPath = '/fileAndDataupload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileDataUpload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileDataUpload$Response(params: {
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
'file'?: Blob;
'bucketName'?: string;
'type'?: string;
'sId'?: number;
'fileType'?: number;
'createdDate'?: string;
'userId'?: string;
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FileUploadControllerService.FileUploadControllerFileDataUploadPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fileDataUpload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileDataUpload(params: {
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
'file'?: Blob;
'bucketName'?: string;
'type'?: string;
'sId'?: number;
'fileType'?: number;
'createdDate'?: string;
'userId'?: string;
}
  }
): Observable<{
}> {

    return this.fileDataUpload$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation fileUploadControllerFileUpload
   */
  static readonly FileUploadControllerFileUploadPath = '/files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileUpload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileUpload$Response(params: {
    context?: HttpContext

    /**
     * Request body for multipart/form-data based file upload
     */
    body: {
'file'?: Blob;
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FileUploadControllerService.FileUploadControllerFileUploadPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fileUpload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileUpload(params: {
    context?: HttpContext

    /**
     * Request body for multipart/form-data based file upload
     */
    body: {
'file'?: Blob;
}
  }
): Observable<{
}> {

    return this.fileUpload$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

}
